import React from 'react';
import { PAGE_CONFIG } from './pageConfig';
import CommonPageRender from '@/pages/dashboard/components/PageContainer/CommonPageRender';
import './index.scss';

const reqParams = '/changeAnalysis';

const ChangeAnalysis = () => (
  <div className='dbd-change-analysis dbd-scroll-body'>
    {/* @ts-ignore */}
    <CommonPageRender reqParams={reqParams} pageConfigInit={PAGE_CONFIG}/>
  </div>
);

export default ChangeAnalysis;
